<template>
  <div>
    <div id="vertify" v-if="text == '验证码'"></div>
    <div id="pwdbox" v-if="text == '密码'"></div>
    <CommonButton id="telbox" v-if="text == '手机号'" :buttonTitle="codeText" :isDisable="telIsDisable" class="get-register" :type="''" v-show="isShow"/>
  </div>
</template>
<script>
/* eslint-disable */
import CommonButton from "@/components/CommonButton"
export default {
  components: {
    CommonButton,
  },
  props: {
    text: {
      type: String,
      default : ''
    },
    telephone: {
      type: String,
      default: ''
    },
    codeText: {
      type: String,
      default: ''
    },
    telIsDisable: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      validInfo: '',
      isShow: false,
    }
  },
  watch: {
    telephone:{
      handler() {
        if(this.telephone) {
          this.isShow = true
        }else {
          this.isShow = false
        }
      },
      deep: true
    },
  },
  methods: {
    getYpRiddler() {
      var that = this
      // 初始化
      new YpRiddler({
        expired: 10,
        mode: "dialog",
        winWidth: 350,
        lang: "zh-cn", // 界面语言, 目前支持: 中文简体 zh-cn, 英语 en
        // langPack: LANG_OTHER, // 你可以通过该参数自定义语言包, 其优先级高于lang
        container:  that.text == '密码' ? document.getElementById("pwdbox") : (that.text == '验证码' ? document.getElementById("vertify") : document.getElementById("telbox")),
        appId: that.text == '手机号' ? that.$config.verificateAppId : that.$config.loginAppId ,
        version: "v1",
        noButton: that.text == '手机号' ? true : false,
        onError: function (param) {
          if (!param.code) {
            console.error("错误请求");
          } else if (parseInt(param.code / 100) == 5) {
            // 服务不可用时，开发者可采取替代方案
            console.error("验证服务暂不可用");
          } else if (param.code == 429) {
            console.warn("请求过于频繁，请稍后再试");
          } else if (param.code == 403) {
            console.warn("请求受限，请稍后再试");
          } else if (param.code == 400) {
            console.warn("非法请求，请检查参数");
          }
          // 异常回调
          console.error("验证服务异常");
        },
        onSuccess: function (validInfo, close, useDefaultSuccess) {
          that.validInfo = validInfo
          if(that.text == '手机号') {
            that.$emit("onSuccess", that.validInfo, '手机号')
          } else if(that.text == '验证码') {
            that.$emit("onSuccess", that.validInfo, '验证码')
          } else {
            that.$emit("onSuccess", that.validInfo, '密码' )
          }
          // 验证成功默认样式
          useDefaultSuccess(true);
          close();
          return validInfo
        },
        onFail: function (code, msg, retry) {
          // 失败回调
          retry();
        },
        beforeStart: function (next) {
          console.log("验证马上开始");
          next();
        },
        onExit: function () {
          // 退出验证 （仅限dialog模式有效）
          console.log("退出验证");
        },
      });
    }
  },
  mounted() {
    this.getYpRiddler()
  },
};
</script>
<style scoped lang="stylus">
  .get-register
    width: 120px
</style>